import React from 'react';
import cn from 'classnames';
import PriorityModifier from './PriorityModifier';

const DesignerLine = ({ designer, updateDesignerPriority }) => {
  const disabledDesigner = (designer.priority || 5) >= 5;
  const deactivatedDesigner = designer.active === false || disabledDesigner;
  return (
    <div key={designer.id} className={cn('designer-info', { '-deactivated-designer': deactivatedDesigner })}>
      <div className="designer-priority">
        <PriorityModifier designer={designer} updateDesignerPriority={updateDesignerPriority} />
      </div>
      <div className="designer-avatar">
        {designer.avatar && (
          <img src={designer.avatar.url} />
        )}
        {!designer.avatar && (
          <div className="designer-initials">{designer.initials}</div>
        )}
      </div>
      <div className={cn('designer-name', { '-disabled-designer': deactivatedDesigner })}>{designer.full_name}</div>
    </div>
  );
};
export default DesignerLine;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/DesignerLine.js